import { NonIndexRouteWithFullPath, Module, SubModule } from "../../models/Modules";

/**
 * This function returns formatted menu item data
 * @param {userModuleResponse[]}  - module api response stored in state
 *
 * @returns route menu item data array
 */
export const prepareMenuItems = (userModuleResponse: Module[]): Module[] => {
  const inputArray = Array.isArray(userModuleResponse)
    ? JSON.parse(JSON.stringify(userModuleResponse))
    : [];
  
  // Create a map to store submodules by their subModuleId
  const subModuleMap: { [key: number]: SubModule } = {};

  // Iterate over the submodules and store them in the map
  inputArray.forEach((module: Module) => {
    (module.subModules || []).forEach((subModule) => {
      const { subModuleId } = subModule;
      subModuleMap[subModuleId] = subModule;
    });
  });
  inputArray.forEach((module: Module) => {
    (module.subModules || []).forEach((subModule) => {
      const { parentSubModuleId } = subModule;
      if (parentSubModuleId !== -1) {
        const parentSubModule = subModuleMap[parentSubModuleId];
        if (parentSubModule) {
          if (!parentSubModule.subModules) {
            parentSubModule.subModules = [];
          }
          parentSubModule.subModules.push(subModule);
        }
      }
    });
  });
  inputArray.forEach((module: Module) => {
    module.subModules = (module.subModules || []).filter(
      (subModule) => subModule.parentSubModuleId === -1
    );
  });

  const updateModuleFullRoutePath = (
    subModule: SubModule,
    parentRoutePath = ""
  ): void => {
    const fullRoutePath = `${parentRoutePath}/${subModule.routeUrl}`;
    subModule.fullRoutePath = fullRoutePath;
    if (subModule.subModules) {
      subModule.subModules.forEach((childSubModule) => {
        updateModuleFullRoutePath(childSubModule, fullRoutePath);
      });
    }
  };

  inputArray.forEach((module: Module) => {
    (module.subModules || []).forEach((subModule) => {
      updateModuleFullRoutePath(subModule, module.routeUrl);
    });
  });
  return inputArray;
};

/**
 * This function returns matching route url from webpage and checkroutestatus state data
 * @param {NonIndexRouteWithFullPath[]}  routeMappingArray - predefined routes
 * @returns updated route whose structure matches with the structure with module api response
 */

export const updateRouteObjectFullRoutePath = (
  routeMappingArray: NonIndexRouteWithFullPath[]
) => {
  const updateRouteFullRoutePath = (
    routeObj: NonIndexRouteWithFullPath,
    parentPath: string | undefined
  ) => {
    const parent = (parentPath || "").replace(/\/+$/, "");
    const child = (routeObj.path || "").replace(/^\/+/, "");
    routeObj.fullRoutePath = `${parent}/${child}`;
    if (routeObj.children) {
      routeObj.children.forEach((routeObjChild: NonIndexRouteWithFullPath) => {
        updateRouteFullRoutePath(routeObjChild, routeObj.fullRoutePath);
      });
    }
    return routeObj;
  };

  routeMappingArray.forEach((routeObj: NonIndexRouteWithFullPath) => {
    routeObj.fullRoutePath = routeObj.path;
    if (routeObj.children) {
      routeObj.children.forEach((routeObjChild: NonIndexRouteWithFullPath) => {
        updateRouteFullRoutePath(routeObjChild, routeObj.path);
      });
    }
  });

  return routeMappingArray;
};
